import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CallStartState } from "./callStart.state";
import { CallStartData } from "./callStart.types";
import { getCallStart } from "./callStart.thunk";

const initialState: CallStartState = {
  data: null,
  status: "idle",
  error: null,
};

const callStartSlice = createSlice({
  name: "callStart",
  initialState,
  reducers: {
    resetCallStart: (state) => {
      state.data = null;
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCallStart.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(
        getCallStart.fulfilled,
        (state, action: PayloadAction<CallStartData>) => {
          state.status = "success";
          state.data = action.payload;
        },
      )
      .addCase(
        getCallStart.rejected,
        (state, action: PayloadAction<string | undefined>) => {
          state.status = "error";
          state.error = action.payload ?? "Arama başlatılamadı.";
        },
      );
  },
});

export const { resetCallStart } = callStartSlice.actions;
export default callStartSlice.reducer;